import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import "./WeLaunch.css";
import { CmsText } from "../../../RichTextContent/RichTextContent";
import { useHomeSection } from "../../../../context/HomePageContext";
import { resolveMediaUrl } from "../../../../utils/resolveMediaUrl";
import {
  isVideoUrl,
  videoMimeFromUrl,
} from "../../../../utils/mediaPaths";

function WeLaunchVisual({ src }) {
  if (!src) return null;
  if (isVideoUrl(src)) {
    return (
      <video
        key={src}
        className="welaunch-right__media"
        autoPlay
        loop
        muted
        playsInline
      >
        <source src={src} type={videoMimeFromUrl(src)} />
      </video>
    );
  }
  return (
    <img
      className="welaunch-right__media"
      src={src}
      alt=""
      decoding="async"
    />
  );
}

const WeLaunch = () => {
  const { section, loading } = useHomeSection("welaunch");

  const visualSrc = useMemo(() => {
    const url = section?.media?.primary?.url;
    return url ? resolveMediaUrl(url) : "";
  }, [section]);

  if (loading || !section?.fields) return null;

  const fields = section.fields;

  return (
    <section className="welaunch">
      <div className="welaunch-card">
        <div className="welaunch-left">
          <h2>
            {fields.titleLine1 ? (
              <>
                <CmsText content={fields.titleLine1} as="span" />
                {fields.titleLine2 ? (
                  <>
                    <br />
                    <CmsText
                      content={fields.titleLine2}
                      as="span"
                      className="underline"
                    />
                  </>
                ) : null}
              </>
            ) : fields.titleLine2 ? (
              <CmsText
                content={fields.titleLine2}
                as="span"
                className="underline"
              />
            ) : null}
          </h2>

          {fields.subtitle ? (
            <CmsText content={fields.subtitle} as="p" />
          ) : null}

          {fields.buttonLink ? (
            <Link to={fields.buttonLink} className="welaunch-btn buttonclip">
              <CmsText content={fields.buttonText} as="span" />
            </Link>
          ) : null}
        </div>

        <div className="welaunch-right">
          {visualSrc ? <WeLaunchVisual src={visualSrc} /> : null}
        </div>
      </div>
    </section>
  );
};

export default WeLaunch;
